import Tool from "../Tool"

const Meta = Tool.extend({
  bindEvents(el, activate) {
    const selBtn = this.editor.getElement("meta-sel");
    selBtn.addEventListener("click", activate);

    this.form = this.editor.getElement("meta-form");

    this.form.addEventListener("submit", evt => {
      evt.preventDefault();

      const meta = this.form.elements.meta.value;
      let parsed, serialized;
      let format = "serialized";

      try {
        parsed = JSON.parse(meta);
        serialized = VOID.utils.PHP_serialize(parsed);
      } catch (e) {
        if(confirm(`Obsah neni validni JSON, presto odeslat?\n${e.message}`)) {
          serialized = meta;
          format = "string";
        } else {
          return;
        }
      }

      const url = this.editor.makeURL(`Act=setmeta&meta=${encodeURIComponent(serialized)}&format=${format}`);

      AJAX.send({
        scope: this.editor.getAJAXScope(),
        callback: (data) => {
          this.editor.setURL(data.pics.http);
          this.editor.history.push();
          activate();
          this.editor.meta.meta = parsed;
        },
        url
      });
    })
  },

  open() {
    this.updateValue();
  },

  enter() {
    this.updateValue();
  },

  updateValue() {
    this.form.elements.meta.value = this.editor.meta.meta ? JSON.stringify(this.editor.meta.meta, null, 2) : "";
  }
});

export default Meta;
